import Layout from "../../Internal/Layout.vue";
import Payments from "./Payments.vue";
import Transfers from "./Transfers.vue";
import Withdrawal from "./Withdrawal.vue";
import Shipments from "./Shipments.vue";

const ProductResaleRoutes = {
  component: Layout,
  children: [
    {
      path: "/financial-payments",
      name: "Payments",
      component: Payments,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
        requiresFinancial: true,
      },
    },
    {
      path: "/financial-receivables",
      name: "Transfers",
      component: Transfers,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
        requiresFinancial: true,
      },
    },
    {
      path: "/financial-withdrawal",
      name: "Withdrawal",
      component: Withdrawal,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
        requiresFinancial: true,
      },
    },
    {
      path: "/financeiro-transacoes",
      name: "Shipments",
      component: Shipments,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
        requiresFinancial: true,
      },
    },
  ],
};

export default ProductResaleRoutes;
